module.exports = __webpack_public_path__ + "img/8_8.0836b308.png";